import React from 'react'
import PageLayout from '@/components/PageLayout'
import Dashboard from '@/components/dashboard/Dashboard'
import Attestation from '@/components/dashboard/Attestation'
import { FlexCol } from '@/components/common/Columns'
import TransactionHistory from '@/components/dashboard/TransactionHistory'
import { setPageCache } from '@/cache'

const DashboardPage = () => {
  return (
    <PageLayout>
      <FlexCol
        maxWidth={{ xs: '100%', md: 1228 }}
        margin={'0 auto'}
        px={{ xs: 24, md: 32 }}
        py={32}
        sx={{ rowGap: 60 }}
      >
        <Dashboard />

        <TransactionHistory />

        <Attestation />
      </FlexCol>
    </PageLayout>
  )
}

export default DashboardPage

export async function getServerSideProps({ req, res }) {
  setPageCache(req, res)

  return {
    props: {},
  }
}
